export interface ChangeWorkOrderCurrentStage {
	stage: number;
	workOrderId: number;
}

export class ChangeWorkOrderCurrentStage implements ChangeWorkOrderCurrentStage {	
	constructor(data?: Partial<ChangeWorkOrderCurrentStage>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}